import React, { useState } from 'react';

const CartContext = React.createContext();

export function CartContextProvider({ children }) {
  const [cart, setCart] = useState();
  const [collectionsInCart, setCollectionsInCart] = useState();

  return (
    <CartContext.Provider
      value={{ cart, collectionsInCart, setCart, setCollectionsInCart }}
    >
      {children}
    </CartContext.Provider>
  );
}

export default CartContext;
